export function formatDate(date: Date | string | undefined) {
  if (!date) {
    return "";
  }

  if (typeof date === "string") {
    date = new Date(date);
  }

  return date.toLocaleString("en-AU", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function daysDifferenceBetweenDates(dateOne: Date, dateTwo: Date): number {
  const timeDifference = dateTwo.getTime() - dateOne.getTime();
  const daysDifference = timeDifference / (1000 * 3600 * 24);
  return Math.abs(Math.round(daysDifference));
}
